module.exports = __webpack_public_path__ + "static/media/premiers.22ed3638.svg";